import {createReducer, on} from '@ngrx/store';
import {
  loadFormData,
  loadFormDataFailure,
  loadFormDataSuccess,
  updateFormData,
  updateFormDataFailure,
  updateFormDataSuccess
} from '../actions/my-settings.actions';
import {NotificationFormData} from "../../services/my-settings.common.service";

export interface MySettingsState {
  loading: number;
  pending: number;
  formData: NotificationFormData;
}

export const mySettingsInitialState: MySettingsState = {
  loading: 0,
  pending: 0,
  formData: {
    topics: [],
    preferences: [],
    areas: [],
    subscribedAreas: []
  }
};

export const mySettingsReducer = createReducer(
  mySettingsInitialState,
  on(loadFormData, state => ({...state, loading: state.loading + 1})),
  on(loadFormDataSuccess, (state, action) => ({...state, formData: action.formData, loading: state.loading - 1})),
  on(loadFormDataFailure, state => ({...state, loading: state.loading - 1})),

  on(updateFormData, state => ({...state, pending: state.pending + 1})),
  on(updateFormDataSuccess, (state, action) => ({
    ...state,
    pending: state.pending - 1,
    formData: action.formData
  })),
  on(updateFormDataFailure, state => ({...state, pending: state.pending - 1}))
);
